import { render, staticRenderFns } from "./CreateSubcontractor.vue?vue&type=template&id=07a4a324"
import script from "./CreateSubcontractor.vue?vue&type=script&lang=js"
export * from "./CreateSubcontractor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports